import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  resetStepTwoState,
  setPaymentInstrument,
} from '../make-payment/step-two-amount/makePaymentStepTwoReducer';
import { resetState } from './accountDetailsReducer';
import {
  EditPaymentScheduleButtonContainer,
  PaymentScheduleCancelButton,
  SaveNewPaymentScheduleButton,
} from './styles';
import {
  checkSaveDisabledStatementAccount,
  collapseEventBody,
  updatePayMethodBody,
  updatePayPlanBody,
} from './utils';
import { updateStatementPayPlan } from './policyAPI';
import { useSnackbar } from 'notistack';
import { ga4Event } from '../../../utils/google-analytics-4';
import { Loader } from '../../common/loader';
import { payPlanDateCheck } from '../../../utils/validators/generalValidators';

export const CancelSaveContainerStatementAccount = (props) => {
  const {
    account,
    dispatch,
    customerId,
    billingStatusCd,
    hasOpenBalance,
    initialState,
    isLoading,
    instrumentToPayWith,
    newStatementPlan,
    statementPayPlanDateToPay,
    setShowEditPaymentMethod,
    setShowEditPaymentSchedule,
    setShowPaymentSchedule,
    showPaymentSchedule,
    showEditPaymentMethod,
    showEditPaymentSchedule,
    billingAccountsCountLimit,
    revision,
  } = props;
  const { enqueueSnackbar } = useSnackbar();

  const SaveStatementAccountPaySchedule = async (accountId, account) => {
    if (payPlanDateCheck(statementPayPlanDateToPay, enqueueSnackbar)) {
      return;
    }
    if (
      window.confirm(
        'This will endorse all policies with the billing changes you have made. Do you want to continue?',
      )
    ) {
      if (showEditPaymentSchedule[accountId] === true) {
        const body = updatePayPlanBody(
          instrumentToPayWith,
          newStatementPlan,
          Math.abs(statementPayPlanDateToPay),
          customerId,
          account?.fullAccount?.underlyingBillingAccounts[1]?.arPolicy?.carrierCd,
          revision,
          true,
        );
        await dispatch(
          updateStatementPayPlan(
            account.fullAccount.statementAccountRef,
            body,
            enqueueSnackbar,
            customerId,
            hasOpenBalance,
            billingAccountsCountLimit,
            billingStatusCd,
          ),
        );
        dispatch(resetState());
        dispatch(resetStepTwoState());
        setShowPaymentSchedule(initialState);
        setShowEditPaymentSchedule(initialState);
      }
      if (showEditPaymentMethod[accountId] === true) {
        const body = updatePayMethodBody(
          instrumentToPayWith,
          account,
          customerId,
          account?.fullAccount?.underlyingBillingAccounts[1]?.arPolicy?.carrierCd,
          revision,
          true,
        );
        await dispatch(
          updateStatementPayPlan(
            account.fullAccount.statementAccountRef,
            body,
            enqueueSnackbar,
            customerId,
            hasOpenBalance,
            billingAccountsCountLimit,
            billingStatusCd,
          ),
        );
        dispatch(resetState());
        dispatch(resetStepTwoState());
        setShowPaymentSchedule(initialState);
        setShowEditPaymentSchedule(initialState);
        setShowEditPaymentMethod(initialState);
      }
    }
  };

  return (
    <EditPaymentScheduleButtonContainer>
      <PaymentScheduleCancelButton
        onClick={() => {
          ga4Event(collapseEventBody);
          setShowPaymentSchedule({
            ...showPaymentSchedule,
            [account.fullAccount.id]: !showPaymentSchedule[account.fullAccount.id],
          });
          dispatch(setPaymentInstrument(null));
          setShowEditPaymentSchedule(initialState);
          setShowEditPaymentMethod(initialState);
        }}
      >
        Cancel
      </PaymentScheduleCancelButton>
      <SaveNewPaymentScheduleButton
        disabled={
          !checkSaveDisabledStatementAccount(
            newStatementPlan,
            instrumentToPayWith,
            statementPayPlanDateToPay,
            isLoading,
            showEditPaymentMethod,
            account.fullAccount.id,
          )
        }
        onClick={() => SaveStatementAccountPaySchedule(account.fullAccount.id, account)}
      >
        Save
      </SaveNewPaymentScheduleButton>
      {isLoading && <Loader loaderheight="20px" loaderwidth="20px" />}
    </EditPaymentScheduleButtonContainer>
  );
};
CancelSaveContainerStatementAccount.propTypes = {
  customerId: PropTypes.string,
  dispatch: PropTypes.func,
  initialState: PropTypes.object,
  billingStatusCd: PropTypes.string,
  isLoading: PropTypes.bool,
  instrumentToPayWith: PropTypes.object,
  statementPayPlanDateToPay: PropTypes.string,
  payPlanOptions: PropTypes.array,
  policyToUpdatePayPlan: PropTypes.object,
  newStatementPlan: PropTypes.object,
  revision: PropTypes.string,
  setShowEditPaymentMethod: PropTypes.func,
  setPolicyToUpdatePayPlan: PropTypes.func,
  setShowEditPaymentSchedule: PropTypes.func,
  setShowPaymentSchedule: PropTypes.func,
  showEditPaymentMethod: PropTypes.object,
  showEditPaymentSchedule: PropTypes.object,
  showPaymentSchedule: PropTypes.object,
  account: PropTypes.object,
  hasOpenBalance: PropTypes.bool,
  billingAccountsCountLimit: PropTypes.string,
};
export const mapStateToProps = (state) => ({
  state,
  billingAccounts: state.billingSlice.billingAccounts,
  billingStatusCd: state.configurationSlice?.features?.billingStatusCd
    ? state.configurationSlice.features.billingStatusCd
    : '',
  instrumentToPayWith: state.makePaymentStepTwoSlice.instrumentToPayWith,
  statementPayPlanDateToPay: state.accountDetailsSlice.statementPayPlanDateToPay,
  payPlanOptions: state.accountDetailsSlice.payPlanOptions,
  newStatementPlan: state.accountDetailsSlice.newStatementPlan,
  customerId: state.customerSlice.customer.systemId,
  editPayPlan: state.configurationSlice.features.features.editPayPlan,
  hasOpenBalance: state.configurationSlice.features.features.hasOpenBalance,
  policies: state.policySlice.policies,
  isLoading: state.accountDetailsSlice.isLoading,
  revision: state.accountDetailsSlice.revision,
  billingAccountsCountLimit: state.configurationSlice.features.billingAccountsCountLimit,
});

export default connect(mapStateToProps)(CancelSaveContainerStatementAccount);
